<template>
  <svg
    width="142"
    height="142"
    viewBox="0 0 142 142"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="71" cy="71" r="68.5" stroke="#0071BC" stroke-width="5" />
    <path
      d="M53.9991 92L100.668 45.331C102.23 43.7689 104.763 43.7689 106.325 45.331L107.739 46.7452C109.301 48.3073 109.301 50.84 107.739 52.4021L63.8986 96.2427C62.3365 97.8048 59.8039 97.8048 58.2418 96.2427L53.9991 92Z"
      fill="#0071BC"
    />
    <path
      d="M63.8276 96.1716C62.2655 97.7337 59.7328 97.7337 58.1707 96.1716L35.5433 73.5442C33.9812 71.9821 33.9812 69.4494 35.5433 67.8873L36.9575 66.4731C38.5196 64.911 41.0523 64.911 42.6144 66.4731L65.2418 89.1005C66.8039 90.6626 66.8039 93.1953 65.2418 94.7574L63.8276 96.1716Z"
      fill="#0071BC"
    />
  </svg>
</template>
